import { Fade } from '@mui/material';
import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    classes: {
      paper: 'MuiCustomScrollbarHelper', // add custom scrollbar helper class to the list
    },
    slots: {
      transition: Fade,
    },
    slotProps: {
      list: {
        disablePadding: true,
      },
    },
    hasTopSpacing: true,
  },
  variants: [
    {
      props: { hasTopSpacing: true },
      style: {
        transform: 'translateY(2px)', // add top spacing by translating the menu downwards
      },
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: scssVariables.BorderRadiusMedium,

      '.MuiMenu-paper': {
        boxShadow: scssVariables.BoxShadowSmall,
        paddingBlock: theme.spacing(2),
        paddingInline: theme.spacing(1.5),
      },

      '.MuiListSubheader-root': {
        '&:not(:first-child)': {
          marginTop: theme.spacing(2.5),
        },

        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: '100%',
          left: 0,
          width: '100%',
          height: theme.spacing(2),
          backgroundColor: scssVariables.ColorBlack10,

          ...theme.applyStyles('dark', {
            backgroundColor: scssVariables.ColorBlack100,
          }),
        },
      },
    }),
  },
};
